module.exports = __webpack_public_path__ + "img/ifs-logo-335x56.bb74a748.png";